import { render, staticRenderFns } from "./StudentPosterBorder.vue?vue&type=template&id=5ed2eb0f&scoped=true&"
import script from "./StudentPosterBorder.vue?vue&type=script&lang=js&"
export * from "./StudentPosterBorder.vue?vue&type=script&lang=js&"
import style0 from "./StudentPosterBorder.vue?vue&type=style&index=0&id=5ed2eb0f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed2eb0f",
  null
  
)

export default component.exports